import { Component } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MessagesService, SnackMessageModel, } from '../../services/messages.service';


@Component({
  selector: 'snack-bar',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './snack-bar.component.html',
  styleUrl: './snack-bar.component.scss'
})
export class SnackBarComponent {


  constructor(public readonly messageService: MessagesService) {

  }

  dismissMessage(msg: SnackMessageModel): void {
    this.messageService.dismissMessage(msg);
  }
}
